import { Company } from './company.model';

export class Verifier extends Company {

}
